export const checklistsTranslations = {
  fr: {
    title: "Checklists Médicales",
    subtitle: "Procédures standardisées pour améliorer la sécurité des soins",
    filterBySpecialty: "Filtrer par spécialité",
    loading: "Chargement des checklists...",
    noChecklists: "Aucune checklist disponible",
    noChecklistsDesc: "Les checklists apparaîtront ici une fois chargées.",
    steps: "étapes",
    critical: "Critique",
    completed: "Terminé",
    times: "fois",
    startProcedure: "Démarrer la procédure",
    step: "Étape",
    progression: "Progression",
    sessionNotes: "Notes de session",
    sessionNotesDesc: "Ajoutez des observations ou commentaires sur cette procédure",
    notesPlaceholder: "Observations, difficultés rencontrées, points d'amélioration...",
    nextStep: "Étape suivante",
    cancel: "Annuler",
    finish: "Terminer",
    sessionStarted: "Session démarrée avec succès",
    sessionStartError: "Erreur lors du démarrage de la session",
    criticalStepsCompleted: "Toutes les étapes critiques ont été complétées",
    updateError: "Erreur lors de la mise à jour",
    finalizationError: "Erreur lors de la finalisation",
    addedToFavorites: "Ajouté aux favoris",
    removedFromFavorites: "Retiré des favoris",
    nav: {
      dashboard: "Tableau de bord",
      checklists: "Checklists"
    },
    specialties: {
      all: "Toutes les spécialités",
      emergency: "MÉDECINE D'URGENCE",
      anesthesia: "ANESTHÉSIE - RÉANIMATION",
      orthopedics: "ORTHOPÉDIE / TRAUMATOLOGIE",
      neurology: "NEUROLOGIE",
      surgery: "CHIRURGIE",
      cardiology: "CARDIOLOGIE",
      intensive_care: "RÉANIMATION",
      pediatrics: "PÉDIATRIE",
      obstetrics: "OBSTÉTRIQUE"
    },
    categories: {
      preparation: "Préparation",
      procedure: "Procédure",
      verification: "Vérification",
      post_procedure: "Post-procédure"
    },
    actions: {
      start: "Démarrer",
      pause: "Pause",
      resume: "Reprendre",
      complete: "Compléter",
      reset: "Réinitialiser",
      save: "Sauvegarder"
    },
    search: "Rechercher une checklist...",
    sort: {
      default: "Par défaut",
      alpha: "Alphabétique",
      steps: "Nombre d'étapes",
      usage: "Plus utilisés"
    }
  },
  en: {
    title: "Medical Checklists",
    subtitle: "Standardized procedures to improve patient safety",
    filterBySpecialty: "Filter by specialty",
    loading: "Loading checklists...",
    noChecklists: "No checklists available",
    noChecklistsDesc: "Checklists will appear here once loaded.",
    steps: "steps",
    critical: "Critical",
    completed: "Completed",
    times: "times",
    startProcedure: "Start procedure",
    step: "Step",
    progression: "Progress",
    sessionNotes: "Session notes",
    sessionNotesDesc: "Add observations or comments about this procedure",
    notesPlaceholder: "Observations, encountered difficulties, improvement points...",
    nextStep: "Next step",
    cancel: "Cancel",
    finish: "Finish",
    sessionStarted: "Session started successfully",
    sessionStartError: "Error starting session",
    criticalStepsCompleted: "All critical steps have been completed",
    updateError: "Error during update",
    finalizationError: "Error during finalization",
    addedToFavorites: "Added to favorites",
    removedFromFavorites: "Removed from favorites",
    nav: {
      dashboard: "Dashboard",
      checklists: "Checklists"
    },
    specialties: {
      all: "All specialties",
      emergency: "EMERGENCY MEDICINE",
      anesthesia: "ANESTHESIOLOGY - INTENSIVE CARE",
      orthopedics: "ORTHOPEDICS / TRAUMATOLOGY",
      neurology: "NEUROLOGY",
      surgery: "SURGERY",
      cardiology: "CARDIOLOGY",
      intensive_care: "INTENSIVE CARE",
      pediatrics: "PEDIATRICS",
      obstetrics: "OBSTETRICS"
    },
    categories: {
      preparation: "Preparation",
      procedure: "Procedure",
      verification: "Verification",
      post_procedure: "Post-procedure"
    },
    actions: {
      start: "Start",
      pause: "Pause",
      resume: "Resume",
      complete: "Complete",
      reset: "Reset",
      save: "Save"
    },
    search: "Search checklists...",
    sort: {
      default: "Default",
      alpha: "Alphabetical",
      steps: "Number of steps",
      usage: "Most used"
    }
  },
  es: {
    title: "Listas de Verificación Médicas",
    subtitle: "Procedimientos estandarizados para mejorar la seguridad del paciente",
    filterBySpecialty: "Filtrar por especialidad",
    loading: "Cargando listas de verificación...",
    noChecklists: "No hay listas disponibles",
    noChecklistsDesc: "Las listas aparecerán aquí una vez cargadas.",
    steps: "pasos",
    critical: "Crítico",
    completed: "Completado",
    times: "veces",
    startProcedure: "Iniciar procedimiento",
    step: "Paso",
    progression: "Progreso",
    sessionNotes: "Notas de sesión",
    sessionNotesDesc: "Agregue observaciones o comentarios sobre este procedimiento",
    notesPlaceholder: "Observaciones, dificultades encontradas, puntos de mejora...",
    nextStep: "Siguiente paso",
    cancel: "Cancelar",
    finish: "Finalizar",
    sessionStarted: "Sesión iniciada exitosamente",
    sessionStartError: "Error al iniciar sesión",
    criticalStepsCompleted: "Todos los pasos críticos han sido completados",
    updateError: "Error durante la actualización",
    finalizationError: "Error durante la finalización",
    addedToFavorites: "Agregado a favoritos",
    removedFromFavorites: "Eliminado de favoritos",
    nav: {
      dashboard: "Panel de control",
      checklists: "Listas de verificación"
    },
    specialties: {
      all: "Todas las especialidades",
      emergency: "MEDICINA DE EMERGENCIA",
      anesthesia: "ANESTESIOLOGÍA - CUIDADOS INTENSIVOS",
      orthopedics: "ORTOPEDIA / TRAUMATOLOGÍA",
      neurology: "NEUROLOGÍA",
      surgery: "CIRUGÍA",
      cardiology: "CARDIOLOGÍA",
      intensive_care: "CUIDADOS INTENSIVOS",
      pediatrics: "PEDIATRÍA",
      obstetrics: "OBSTETRICIA"
    },
    categories: {
      preparation: "Preparación",
      procedure: "Procedimiento",
      verification: "Verificación",
      post_procedure: "Post-procedimiento"
    },
    actions: {
      start: "Iniciar",
      pause: "Pausar",
      resume: "Reanudar",
      complete: "Completar",
      reset: "Reiniciar",
      save: "Guardar"
    },
    search: "Buscar listas de verificación...",
    sort: {
      default: "Por defecto",
      alpha: "Alfabético",
      steps: "Número de pasos",
      usage: "Más usados"
    }
  }
};